import { ExternalChatMessage, isExternalChatMessage } from "domain-entities";
import { CollectionPath } from "Configs/firebase";
import { firestore } from "firebase/app";
import { useRef } from "react";
import { useLazyCollectionStore } from "../../Helpers/LazyLoadingStoreHelper";
import { PerformanceTrace, PerformanceTraceAttributeAndMetric } from "../../Providers/TrackingProvider";

export function useMessagesStore(organizationId: string, channelId: string) {
  const collectionRef = useRef(
      firestore()
          .collection(CollectionPath.ORGANIZATIONS)
          .doc(organizationId)
          .collection(CollectionPath.CHANNELS)
          .doc(channelId)
          .collection(CollectionPath.MESSAGES)
  );

  const sortRef = useRef(
    (a: ExternalChatMessage, b: ExternalChatMessage) =>
      a.timestamp - b.timestamp
  );

  return useLazyCollectionStore<ExternalChatMessage>({
    collection: collectionRef.current,
    is: isExternalChatMessage,
    sort: sortRef.current,
    order: 'timestamp',
    loadAll: true,
    traceName: PerformanceTrace.COLLECTION_EXTERNAL_CHAT_LOADED,
    traceMetric: PerformanceTraceAttributeAndMetric.EXTERNAL_CHAT_MESSAGE_COUNT
  });
}
